import React from 'react';

export const DocentesEncontrados = ({ docentes, onSeleccionarDocente }) => {
  // Clonamos y ordenamos el array por apellido y luego por nombre
  const docentesOrdenados = [...docentes].sort((a, b) => {
    const apellidoA = a.apellido.toLowerCase();
    const apellidoB = b.apellido.toLowerCase();
    if (apellidoA < apellidoB) return -1;
    if (apellidoA > apellidoB) return 1;

    // Si los apellidos son iguales, ordenamos por nombre
    const nombreA = a.nombre.toLowerCase();
    const nombreB = b.nombre.toLowerCase();
    return nombreA.localeCompare(nombreB);
  });

  return (
    <div className='seccion'>
      <h4>Se encontraron varios resultados:</h4>
      {docentesOrdenados.length > 0 ? (
        <ul>
          {docentesOrdenados.map((docente) => (
            <li key={docente.id}>
              <button onClick={() => onSeleccionarDocente(docente)} className='btn-buscar'>
                {docente.apellido} {docente.nombre} - {docente.dni}
                {!docente.tieneMaterias && (
                  <span>🔴</span>
                )}
              </button>
            </li>
          ))}

        </ul>
      ) : (
        <p>No se encontraron docentes.</p>
      )}
    </div>
  );
};
